import * as React from "react";
import styled from "styled-components";
import {} from "@hubper/theme";
import mergeStyles from "../../util/mergeStyles";

import { animated, useSpring } from "react-spring";

const percentToDegree = (value: number) => (value / 100) * 360;

const calcBackgroundImage = (
  colorInactive: string,
  colorActive: string,
  progress: number
) => {
  if (progress <= 50) {
    const degree = 90 + percentToDegree(progress) + "deg";
    return `linear-gradient(90deg, ${colorInactive} 50%, transparent 50%, transparent), linear-gradient(${degree}, ${colorActive} 50%, ${colorInactive} 50%, ${colorInactive})`;
  }

  const degree = -90 + percentToDegree(progress - 50) + "deg";
  return `linear-gradient(${degree}, ${colorActive} 50%, transparent 50%, transparent), linear-gradient(270deg, ${colorActive} 50%, ${colorInactive} 50%, ${colorInactive})`;
};

const Base = styled(animated.div)`
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Inner = styled.div`
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

export type ProgressCircleProps = {
  style?: React.CSSProperties;
  className?: string;
  children?: any;
  progress: number;
  size: string | number;
  lineSize: string;
  backgroundColor: string;
  colorActive: string;
  colorInactive: string;
};

function ProgressCircle(
  {
    style,
    className,
    children,
    progress,
    size,
    lineSize,
    backgroundColor,
    colorActive,
    colorInactive
  }: ProgressCircleProps,
  ref: any
) {
  const baseStyle = useSpring({
    animatedProgress: progress
  });

  return (
    <Base
      ref={ref}
      style={mergeStyles(style, {
        width: size,
        height: size,
        background: baseStyle.animatedProgress.interpolate(x =>
          calcBackgroundImage(colorInactive, colorActive, x)
        )
      })}
      className={className}
    >
      <Inner
        style={{
          backgroundColor,
          width: `calc(100% - ${lineSize})`,
          height: `calc(100% - ${lineSize})`
        }}
      >
        {children}
      </Inner>
    </Base>
  );
}

export default React.forwardRef(ProgressCircle);
